// Merchant signup application queue. Click a row → detail page.

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listApplications } from '../../services/businessService';
import DataTable from '../common/DataTable';

const STATUS_BADGE = {
  pending: 'badge-pending',
  approved: 'badge-active',
  rejected: 'badge-inactive',
  more_info: 'badge-pending',
};

const STATUS_LABEL = {
  pending: 'Pending review',
  approved: 'Approved',
  rejected: 'Rejected',
  more_info: 'More info',
};

export default function AdminApplications() {
  const [data, setData] = useState({
    applications: [], pagination: { page: 1, total: 0, page_size: 50 },
    counts: { pending: 0, approved: 0, rejected: 0, more_info: 0, total: 0 },
  });
  const [status, setStatus] = useState('pending');   // Default to pending — the load-bearing tab
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    let alive = true;
    listApplications({ status, q, page })
      .then(d => { if (alive) setData(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, [status, q, page]);

  const TABS = [
    { key: 'pending', label: 'Pending' },
    { key: 'more_info', label: 'More info' },
    { key: 'approved', label: 'Approved' },
    { key: 'rejected', label: 'Rejected' },
    { key: '', label: 'All' },
  ];

  return (
    <>
      <div className="portal-content-header">
        <h1>Applications</h1>
      </div>

      <div className="portal-application-toolbar">
        <div className="portal-tab-row">
          {TABS.map(t => (
            <button
              key={t.key || 'all'}
              type="button"
              className={`portal-button ${status === t.key ? '' : 'secondary'}`}
              onClick={() => { setStatus(t.key); setPage(1); }}
            >
              {t.label}
              {t.key && data.counts[t.key] > 0 && (
                <span style={{ marginLeft: 6, opacity: 0.85, fontWeight: 700 }}>
                  ({data.counts[t.key]})
                </span>
              )}
              {!t.key && data.counts.total > 0 && (
                <span style={{ marginLeft: 6, opacity: 0.85, fontWeight: 700 }}>
                  ({data.counts.total})
                </span>
              )}
            </button>
          ))}
        </div>
        <input
          type="search"
          className="portal-search"
          placeholder="Search company, contact, email"
          value={q}
          onChange={e => { setQ(e.target.value); setPage(1); }}
        />
      </div>

      <DataTable
        columns={[
          { key: 'company_name', label: 'Company', render: a => (
            <Link to={`/admin/applications/${a.id}`}>{a.company_name}</Link>
          ) },
          { key: 'contact_name', label: 'Contact' },
          { key: 'email', label: 'Email', render: a => a.user?.email || '—' },
          { key: 'business_type', label: 'Type' },
          { key: 'document_count', label: 'Docs' },
          { key: 'status', label: 'Status', render: a => <span className={`badge ${STATUS_BADGE[a.status] || 'badge-pending'}`}>{STATUS_LABEL[a.status] || a.status}</span> },
          { key: 'created_at', label: 'Submitted', render: a => new Date(a.created_at).toLocaleString() },
          { key: 'reviewed_by', label: 'Reviewer', render: a => a.reviewed_by || '—' },
        ]}
        rows={data.applications}
        emptyMessage={status === 'pending'
          ? 'No applications waiting for review. 🎉'
          : `No ${STATUS_LABEL[status]?.toLowerCase() || ''} applications.`}
      />

      {data.pagination.total > data.pagination.page_size && (
        <div className="portal-pagination">
          <button type="button" className="portal-button secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</button>
          <span>Page {data.pagination.page}</span>
          <button type="button" className="portal-button secondary" disabled={page * data.pagination.page_size >= data.pagination.total} onClick={() => setPage(p => p + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
